import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class Draggable extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.func.isRequired,
    style: PropTypes.object,
    defaultObjectId: PropTypes.any.isRequired,
    childRef: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.defaultChild = React.createRef();
    this.state = {
      dragging: false, startX: null, dx: 0, dy: 0, draggingObject: null
    };
  }

  setDraggingObject = (draggingObject, { clientX, clientY }) => {
    this.setState({ draggingObject, startX: clientX, startY: clientY });
  };

  setPosition = (currentX, currentY, dragging) => {
    const {
      startX, startY, draggingObject
    } = this.state;
    if (startX !== null) {
      const dx = currentX - startX;
      const dy = currentY - startY;
      this.setState({
        dx,
        dy,
        dragging,
        startX: dragging ? startX : null,
        draggingObject: dragging ? draggingObject : null
      });
    }
  };

  onMouseDown = (e) => {
    if (this.defaultChild.current) {
      this.defaultChild.current.onMouseDown(e);
    }
  };

  onMouseUp = (e) => {
    const { startX } = this.state;
    if (startX) {
      this.setPosition(e.clientX, e.clientY, false);
      e.preventDefault();
      e.stopPropagation();
    }
  };

  onMouseMove = (e) => {
    const { draggingObject } = this.state;
    if (draggingObject) {
      this.setPosition(e.clientX, e.clientY, true);
    }
  };

  render() {
    const {
      dx, dy, dragging, draggingObject
    } = this.state;

    const {
      className, children, style, childRef
    } = this.props;

    const waStyle = {
      cursor: dragging ? 'grabbing' : 'grab',
      ...(style || {})
    };

    return (
      <div
        className={ className }
        style={ waStyle }
        onMouseDown={ this.onMouseDown }
        onMouseUp={ this.onMouseUp }
        onMouseMove={ this.onMouseMove }
        ref={ childRef }
      >
        {
          children({
            dx,
            dy,
            dragging,
            setDraggingObject: this.setDraggingObject,
            draggingObject,
            defaultChild: this.defaultChild
          })
        }
      </div>
    );
  }
}
